export default "__VITE_ASSET__3rco8WMW__"